import { render, staticRenderFns } from "./ShowSurplus.vue?vue&type=template&id=91254172"
import script from "./ShowSurplus.vue?vue&type=script&lang=js"
export * from "./ShowSurplus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports